import { QSO } from "@/types/qso.types";
import { AdifParser } from "adif-parser-ts";
import { formatCall } from "@/utils/string.utils";

export class ADIFParserService {
  /**
   * 解析 ADIF 内容为 QSO 记录
   * @param content ADIF 文件内容
   * @returns 解析后的 QSO 记录数组
   */
  parseADIFToQSORecords(content: string): QSO[] {
    const adifData = AdifParser.parseAdi(content);
    
    if (!adifData.records || adifData.records.length === 0) {
      return [];
    }
    
    const qsoRecords: QSO[] = [];
    
    for (const record of adifData.records) {
      // 检查是否包含必要的 QSO 字段
      if (!record['call'] || !record['qso_date'] || !record['time_on']) {
        continue;
      }
      
      // 构建 QSO 记录
      const rawCall = record['call'];
      const formattedCall = formatCall(rawCall);
      
      const qsoRecord: QSO = {
        id: `${formattedCall}-${record['qso_date']}-${record['time_on']}`,
        call: formattedCall,
        qso_date: record['qso_date'],
        time_on: record['time_on'],
        freq: parseFloat(record['freq'] || '0'),
        band: record['band'] || '',
        mode: record['mode'] || '',
        rst_sent: record['rst_sent'] || '',
        rst_rcvd: record['rst_rcvd'] || '',
        qsl_rcvd: record['qsl_rcvd'] || '',
        pota: record['pota_ref'],
        contest_id: record['contest_id'],
        comment: record['comment'] || record['notes']
      };
      
      qsoRecords.push(qsoRecord);
    }
    
    return qsoRecords;
  }
  
  /**
   * 解析 ADIF 文件为 QSO 记录
   * @param file ADIF 文件对象
   * @returns 解析后的 QSO 记录数组
   */
  async parseADIFFileToQSORecords(file: File): Promise<QSO[]> {
    const content = await file.text();
    return this.parseADIFToQSORecords(content);
  }
}
